@use "styles/abstracts/mixins/common" as c;

.tagsList {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  min-width: 0;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;

  @include c.custom-scrollbar($width: 4px);

  &::-webkit-scrollbar {
    height: 4px;
  }

  &:hover {
    position: relative;
    z-index: 3;
  }
}

.tagItem {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}
